import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { DesignSettingsChangesActions } from './types';

export function actionsDesingSettingsChangedEvent({
  action,
}: {
  action: DesignSettingsChangesActions;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.DESIGN_SETTINGS_CHANGED_ACTIONS,
  };

  pushToDataLayer({
    ...eventAttributes,
    action,
  });
}
